import { FC } from 'react';

interface AnalysisTabProps {
    title: string; // '학생 분석'을 받을 props
    analysis?: ClassAnalysisInfo;
    isStnts: boolean;
}

export const AnalysisTab: FC<AnalysisTabProps> = ({ title, analysis, isStnts }) => {
    return (
        <>
            <div className="tab-report withCheck">
                <button type="button" className="tab active" title="선택됨">
                    {title}
                </button>
            </div>

            <div id="tab_01" style={{ display: 'block' }}>
                <table className="table type2">
                    <caption>우리반 분석 테이블</caption>
                    <colgroup>
                        <col style={{ width: '30%' }} />
                        <col style={{ width: '70%' }} />
                    </colgroup>
                    <tbody>
                        {isStnts && (
                            <tr>
                                <th scope="row">정답률</th>
                                <td className="alignl">
                                    {analysis?.correctRate || analysis?.correctRate === 0
                                        ? analysis?.correctRate
                                        : '-'}
                                </td>
                            </tr>
                        )}
                        <tr>
                            <th scope="row">풀이시간</th>
                            <td className="alignl">
                                {analysis?.solvSecAvr ? analysis?.solvSecAvr : '-'}
                            </td>
                        </tr>
                        <tr>
                            <th scope="row">확인 횟수</th>
                            <td className="alignl">
                                {analysis?.reIdfCntAvg ? analysis?.reIdfCntAvg : '-'}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </>
    );
};
